( function( app ) {
  const COMPONENT = {
    init: function() {},
    finalize: function() {},
  };

  app.registerComponent( 'featured-hero', COMPONENT );
} )( app );
